<template>  
  <map-mission ref="map" :uiid="uiid" maptype="mission" ></map-mission>
</template>
<script>  
  import MapMission from '@/components/map/Map'

  export default {
    name: 'MissionMap',    
    components:{MapMission},    
    props:{
      uiid:{
          type: String,
          required: true,
          default: 'map_global'
      }    
    },
    methods:{
      updateSize() {        
        if(!this.$refs.map) this.$nextTick(this.updateSize)
        else this.$refs.map.updateSize()            
      }
    }
  }
</script>
